import{desc as o}from"./base.js";/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function u(r){return(t,n)=>o(t,n,{async get(){var e;return await this.updateComplete,((e=this.renderRoot)==null?void 0:e.querySelector(r))??null}})}export{u as queryAsync};
